import React, { CSSProperties } from 'react';
import styled from 'styled-components';
import { TextMD, TextSMRegular } from 'styleguide/Texts';
import { View } from 'styleguide/View';
import { ExerciseImage } from '../../../components/ExerciseImage';
import { Spacing } from 'styleguide/spacing';
import { RoutineSet } from 'hevy-shared';

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

interface ExerciseCardProps {
  title: string;
  image?: string;
  sets: RoutineSet[];
  style?: CSSProperties;
}

export const ExerciseCard = ({ title, image, sets, style }: ExerciseCardProps) => {
  const repsLabel = getRepsLabel(sets);
  const setsLabel = getSetsLabel(sets);

  return (
    <Container style={{ ...style }}>
      <View
        style={{
          flexDirection: 'row',
          gap: Spacing.md,
          padding: Spacing.sm,
        }}
      >
        <ExerciseImage diameter={56} source={image} />
        <View style={{ justifyContent: 'center', flex: 1 }}>
          <TextMD>{title}</TextMD>
          {sets && sets.length ? (
            <View style={{ flexDirection: 'row' }}>
              <TextSMRegular>{setsLabel}</TextSMRegular>
              {repsLabel && (
                <>
                  <TextSMRegular style={{ marginLeft: 5, marginRight: 5 }}>·</TextSMRegular>
                  <TextSMRegular>{repsLabel}</TextSMRegular>
                </>
              )}
            </View>
          ) : (
            <div />
          )}
        </View>
      </View>
    </Container>
  );
};

const getRepsLabel = (sets: RoutineSet[]): string | undefined => {
  const workingSet = sets.find(set => set.indicator === 'normal');

  if (!workingSet) {
    return;
  }

  const isReps = !!workingSet.reps;
  if (isReps) {
    return workingSet.reps === 1 ? '1 rep' : workingSet.reps + ' reps';
  }

  const isRepRange = !!workingSet.rep_range?.start && !!workingSet.rep_range?.end;
  if (isRepRange) {
    return workingSet.rep_range?.start + ' - ' + workingSet.rep_range?.end + ' reps';
  }
};

const getSetsLabel = (sets: RoutineSet[]) => {
  return sets.length === 1 ? '1 set' : `${sets.length} sets`;
};
